// extracted by mini-css-extract-plugin
export default {"container":"NotificationModal_container__lurvX","title":"NotificationModal_title__-t2rb","flicker":"NotificationModal_flicker__M6ywz","actions":"NotificationModal_actions__JxOKT"};